export namespace KitTemplateTranslations {
  export const error = {
    kitTemplateInUseByKitError: 'kitTemplateInUseByKitError',
  } as const;
}
